module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel_01_bg-b13dc89bafee0ff26011be419dd3c760.png";